function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 6C8.41365 6 5.14438 7.34716 2.66685 9.5646L1.92172 10.2315L0.587891 8.74125L1.33303 8.07433C4.16306 5.54138 7.90269 4 11.9999 4C16.0972 4 19.8368 5.54138 22.6669 8.07433L23.412 8.74125L22.0782 10.2315L21.333 9.5646C18.8555 7.34716 15.5862 6 11.9999 6Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0002 11C9.6683 11 7.54559 11.8855 5.94627 13.3403L5.20652 14.0132L3.86074 12.5337L4.60049 11.8608C6.55359 10.0842 9.15142 9 12.0002 9C14.8489 9 17.4467 10.0842 19.3998 11.8608L20.1396 12.5337L18.7938 14.0132L18.054 13.3403C16.4547 11.8855 14.332 11 12.0002 11Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 16C10.9633 16 10.0208 16.3931 9.30955 17.04L8.5698 17.7129L7.22403 16.2334L7.96377 15.5605C9.02877 14.5918 10.4465 14 12 14C13.5536 14 14.9713 14.5918 16.0363 15.5605L16.7761 16.2334L15.4303 17.7129L14.6905 17.04C13.9793 16.3931 13.0368 16 12 16Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9999 19H13.0099V21H10.9999V19Z"
});

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.67637284.svg";
export { ForwardRef as ReactComponent };